exports.AD_LOAD = 'V-PLAYER-HUYA-STATISTIC-STATISTIC_EVENT-AD_LOAD'
exports.AD_CLICK = 'V-PLAYER-HUYA-STATISTIC-STATISTIC_EVENT-AD_CLICK'
exports.AD_COMPLETE = 'V-PLAYER-HUYA-STATISTIC-STATISTIC_EVENT-AD_COMPLETE'
exports.AD_ERROR = 'V-PLAYER-HUYA-STATISTIC-STATISTIC_EVENT-AD_ERROR'
exports.AD_NONE = 'V-PLAYER-HUYA-STATISTIC-STATISTIC_EVENT-AD_NONE'
